export default function (props: any) {
    return (
        <svg width="39px" height="38px" viewBox="0 0 39 38" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Refrigerator_icon" transform="translate(0.440662, 0.000000)">
                    <rect id="矩形" x="0" y="0" width="38" height="38"></rect>
                    <g id="编组-67" transform="translate(7.445084, 0.724439)" stroke="#FFFFFF">
                        <path
                            d="M21.1580831,36.5511224 L1.95174831,36.5511224 C1.41514232,36.5511224 0.929285108,36.3348175 0.575707516,35.983738 C0.220466028,35.6309947 2.27373675e-13,35.140981 2.27373675e-13,34.5993868 L2.27373675e-13,1.95256748 C2.27373675e-13,1.42844412 0.206322925,0.951741455 0.542429625,0.601493944 C0.897671112,0.231279829 1.39767143,0 1.95174831,0 L21.1580831,0 C21.7471018,0 22.2753883,0.261229735 22.6331257,0.674704825 C22.9301308,1.01746486 23.1098315,1.46338568 23.1098315,1.95256748 L23.1098315,34.5993868 C23.1098315,35.1767545 22.8585834,35.6958862 22.4609126,36.0527892 C22.1148225,36.3622716 21.6589154,36.5511224 21.1580831,36.5511224 Z"
                            id="Stroke-51"
                            strokeWidth="1.38658989"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <line
                            x1="4.23680243"
                            y1="6.68832964"
                            x2="4.23680243"
                            y2="9.07070918"
                            id="Stroke-53"
                            strokeWidth="1.38658989"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                        <line
                            x1="4.23680243"
                            y1="18.223149"
                            x2="4.23680243"
                            y2="22.4583403"
                            id="Stroke-55"
                            strokeWidth="1.38658989"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                        <line x1="0" y1="13.8112667" x2="23.1098315" y2="13.8112667" id="路径-4" strokeWidth="1.6"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
